<template>
    <div>
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            key-property="envId"
            search-url="/department/search"
            create-url="/department/save"
            delete-url="/department/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            :acceptDelete="false"
        >
        </c-search-form>
        <department-create
            :propsItem="department"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
        />
    </div>
</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import DepartmentCreate from "./DepartmentCreate.vue";
import { cateContants } from "@/constants";

export default {
    name: "env-index",
    components: { DepartmentCreate, CSearchForm },
    data: () => {
        return {
            formName: "Danh sách bộ phận",
            formCreateName: "Thêm mới",
            department: null,
            visibleCreateDialog: false,
            timeReload: 0,
            fields: [
                {
                    value: "index",
                    text: "lang.common.index",
                    width: "5%",
                    sortable: false,
                    headerStyle: "text-align:center",
                },
                {
                    value: "deptName",
                    text: "Tên",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "status",
                    text: "lang.user.status",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "status",
                    items: cateContants.materialStatus,
                    itemText: "text",
                    itemValue: "value",
                },
                {
                    value: "action",
                    text: "lang.common.actions",
                    width: "120px",
                    sortable: false,
                    compound: true,
                    headerStyle: "text-align:center",
                },
            ],
        };
    },

    created() {
        
    },

    methods: {
        openCreateDialog: function (item = null) {
            if (item == null) {
                this.formCreateName = 'Thêm mới';
                this.visibleCreateDialog = true;
            } else {
                this.department = item;
                this.formCreateName = 'Cập nhật';
                this.visibleCreateDialog = true;
            }
        },
        closeCreateDialog: function () {
            this.department = null;
            this.visibleCreateDialog = false;
            this.timeReload = Math.floor(Math.random() * 100);
        },
    },

    destroyed() {},
};
</script>
